import React from 'react';

const Loader = () => {
  return <p style={{ height: '100vh' }}/>;
};
export default Loader;
